import { UIElement } from '../ui-element';

export class StatusIndicatorValueElement extends UIElement {
  static readonly tagName = 'media-status-indicator-value';
}
